import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import superjson from "superjson";
import { env } from "~/env.mjs";

import type { AppRouter } from "~/server/api/root";

export const transformer = superjson;

function getBaseUrl() {
  if (typeof window !== "undefined") return "";
  // In production builds, `env.*` can be inlined at build time. Prefer the runtime
  // environment variable so `next start` can run with `.env.test` overrides.
  // Use bracket-notation to avoid build-time env inlining.
  return (
    process.env.NEXT_PUBLIC_VERCEL_URL_PROTOCOL ??
    env.NEXT_PUBLIC_VERCEL_URL_PROTOCOL
  );
}

export function getUrl() {
  return `${getBaseUrl()}/api/trpc`;
}

/**
 * Inference helper for inputs.
 *
 * @example type HelloInput = RouterInputs['example']['hello']
 */
export type RouterInputs = inferRouterInputs<AppRouter>;

/**
 * Inference helper for outputs.
 *
 * @example type HelloOutput = RouterOutputs['example']['hello']
 */
export type RouterOutputs = inferRouterOutputs<AppRouter>;
